module.exports = __webpack_public_path__ + "img/appointment.b6919828.png";